import React from 'react';
import PropTypes from 'prop-types';
import {FormattedMessage} from "react-intl";

// @mui/material components
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import IconButton from "@mui/material/IconButton";

// @mui/icons-material
import {Close} from "@mui/icons-material";

// core components
import CustomButton from "components/CustomButton";

DeleteRetailerDialog.propTypes = {
    open: PropTypes.bool.isRequired,
    retailer: PropTypes.object,
    onClose: PropTypes.func.isRequired,
    onConfirm: PropTypes.func.isRequired,
};

function DeleteRetailerDialog({open, retailer, onClose, onConfirm}) {
    const retailerName = retailer?.name || '';

    return (
        <Dialog
            open={open}
            onClose={onClose}
            sx={{
                '& .MuiPaper-root': {
                    borderRadius: '12px',
                    maxWidth: '480px',
                    width: '100%',
                    padding: '8px',
                },
            }}
        >
            <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '16px 24px 0'}}>
                <span style={{fontSize: '18px', fontWeight: 700}}>
                    <FormattedMessage id="retailer.list.delete.title" values={{name: retailerName}} />
                </span>
                <IconButton onClick={onClose} size="small">
                    <Close fontSize="small" />
                </IconButton>
            </div>
            <DialogContent sx={{padding: '16px 24px'}}>
                <span style={{fontSize: '14px', color: '#6b7280'}}>
                    <FormattedMessage id="retailer.list.delete.message" values={{name: retailerName}} />
                </span>
            </DialogContent>
            <DialogActions sx={{padding: '8px 24px 16px', gap: '8px'}}>
                <CustomButton variant="contained" color="blue" onClick={onClose}>
                    <FormattedMessage id="retailer.list.delete.cancel" />
                </CustomButton>
                <CustomButton variant="nude" color="red" onClick={() => onConfirm(retailer)}>
                    <FormattedMessage id="retailer.list.delete.confirm" />
                </CustomButton>
            </DialogActions>
        </Dialog>
    );
}

export default DeleteRetailerDialog;
